<template>
  <div>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                <strong>{{ $t('ItemsReport') }}</strong>
              </CCol>
              <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">
                <CButton @click="get_lists" color="dark"
                         size="sm">
                  <CIcon size="sm" name="cil-zoom"/>
                </CButton>
              </CCol>

            </CRow>
          </CCardHeader>
          <br>
          <CRow>

            <CCol col="3">
              <date-picker
                  :label="$t('components.startDate')"
                  v-model="start_date"></date-picker>
            </CCol>
            <CCol col="3">
              <date-picker
                  :label="$t('components.endDate')"
                  v-model="end_date"></date-picker>
            </CCol>
<!--            <CCol col="2">-->
<!--              <CSelect-->
<!--                  :value.sync="selected_branch"-->
<!--                  :options="branch_items"-->
<!--              />-->
<!--            </CCol>-->
            <CCol col="2">
              <CSelect
                  :value.sync="selected_category"
                  :options="category_items"
              />
            </CCol>
            <CCol col="2">
              <select v-model="selected_place" class="form-control"

              >
                <option value="0">
                  {{ $t('components.selectWarehouse') }}
                </option>
                <option v-for="option in places_items" v-bind:value="option.id">
                  {{ option.placeName }}
                </option>
              </select>
            </CCol>
          </CRow>
          <CCardBody>
            <CDataTableFixed
                :items="items_customer"
                :fields="fields"
                sorter
                column-filter
                @row-clicked="table_row_clicked"
height="350px"
                :items-per-page="20"
                hover
                border

                striped
            >
              <template #row_id="{item,index}">

                <td>
                  <p style="text-align: center">{{ index + 1 }}</p>

                </td>

              </template>

<!--              <template #amount="{item}">-->
<!--                <td>-->
<!--                  <p>{{ item.amount }}</p>-->
<!--                </td>-->
<!--              </template>-->
<!--              <template #docDate="{item}">-->
<!--                <td>-->
<!--                  <p>{{ get_date(item.docDate) }}</p>-->
<!--                </td>-->
<!--              </template>-->
              <template #productCode="{item}">
                <td>
                  <p style="text-align: center">{{ item.productCode }}</p>
                </td>
              </template>
<!--              <template #amountNegetive="{item}">-->
<!--                <td>-->
<!--                  <p  style="text-align: right">{{ item.amountNegetive }}</p>-->
<!--                </td>-->
<!--              </template>-->
<!--              <template #accBalance="{item}">-->
<!--                <td>-->
<!--                  <p style="text-align: right">{{ item.accBalance }}</p>-->
<!--                </td>-->
<!--              </template>-->
<!--              <template #accBalanceNegetive="{item}">-->
<!--                <td>-->
<!--                  <p>{{ item.accBalanceNegetive }}</p>-->
<!--                </td>-->
<!--              </template>-->

<!--              <template #kardexAccTypeTitle="{item}">-->
<!--                <td>-->
<!--                  <strong>{{ item.kardexAccTypeTitle }}</strong>-->
<!--                </td>-->
<!--              </template>-->

<!--              <template #masterId="{item}">-->
<!--                <td>-->
<!--                  <a href="javascript:void(0)" class="text-primary" v-on:click="goToDocuments(item)">-->
<!--                    {{ item.masterId }}-->
<!--                    <CIcon name="cil-speedometer"/>-->
<!--                  </a>-->

<!--                </td>-->

<!--              </template>-->

<!--              <template #summary="{item}">-->
<!--                <td>-->
<!--                  <p v-if="item.summary != 'null'">{{ item.summary }}</p>-->
<!--                </td>-->

<!--              </template>-->

<!--              <template #operation="{item}">-->
<!--                <td>-->
<!--                  <CButton-->
<!--                      class="m-1"-->
<!--                      color="primary"-->
<!--                      variant="outline"-->
<!--                      square-->
<!--                      :title="$t('buttons.edit')"-->

<!--                      size="sm"-->
<!--                      @click="goEditPerson(item)"-->
<!--                  >-->
<!--                    <CIcon name="cil-pencil"/>-->
<!--                  </CButton>-->
<!--                  <CButton class="m-1"-->
<!--                           color="success"-->
<!--                           variant="outline"-->
<!--                           square-->
<!--                           size="sm"-->
<!--                           :title="$t('buttons.documents')"-->
<!--                           @click="goToDocuments(item)"-->
<!--                  >-->
<!--                    <CIcon name="cil-list-rich"/>-->
<!--                  </CButton>-->

<!--                </td>-->
<!--              </template>-->


              <template #sumExistanceP="{item}">
                <td>
                  <p  style="text-align: right" v-if="item.sumExistanceP>0">{{ get_currency_no_fix(item.sumExistanceP) }}</p>
                  <p  style="text-align: right" v-else>0</p>
                </td>
              </template>
              <template #bgInvQty="{item}">
                <td>
                  <p style="text-align: right">{{ get_currency_no_fix(item.bgInvQty) }}</p>
                </td>
              </template>
              <template #orginalExistance="{item}">
                <td>
                  <p style="text-align: right">{{ get_currency_no_fix(item.orginalExistance) }}</p>
                </td>
              </template>
              <template #sumExistanceN="{item}">
                <td>
                  <p style="text-align: right" >{{ get_currency_no_fix(Math.abs(item.sumExistanceN)) }}</p>
                </td>
              </template>
<!--              <template #sumAmountP="{item}">-->
<!--                <td>-->
<!--                  <p v-if="item.sumAmount>0">{{ item.sumAmount }}</p>-->
<!--                  <p v-else>0</p>-->

<!--                </td>-->
<!--              </template>-->

<!--              <template #sumAmountN="{item}">-->
<!--                <td>-->
<!--                  <p v-if="item.sumAmount<=0">{{ Math.abs(item.sumAmount) }}</p>-->
<!--                  <p v-else>0</p>-->
<!--                </td>-->
<!--              </template>-->

            </CDataTableFixed>

          </CCardBody>

        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Vue from "vue";
import Treeselect from '@riophae/vue-treeselect'

import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'
import BTabs from "../../tabs/BTabs";

var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
export default {
  name: 'Login',
  components: {
    Treeselect,
  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      VUE_APP_Currency: localStorage.getItem('currency'),
      items_customer: [],
      start_date: '',

      types_all: [],
      types_parent: [],
      selected_type_parent: 0,
      selected_type_child: 0,

      selected_place: 0,
      places_items: [],
      branch_items: [],
      selected_branch: 0,
      category_items: [],
      selected_category: 0,

      end_date: '',
      fields: [
        {key: 'row_id', label: this.$t('tables.row'), sorter: false, _style: 'width:3%'},
        {key: 'productCode', label: this.$t('components.itemCode'), _style: 'width:10%'},
        {key: 'productName', label: this.$t('item'), _style: 'width:20%'},

        {key: 'bgInvQty', label: this.$t('components.first'), _style: 'width:10%'},
        // {key: 'masterCode', label: this.$t('reference'), _style: 'width:10%'},
        // {key: 'partyName', label: this.$t('supplier_customer'), _style: 'width:10%'},

        {key: 'sumExistanceP', label: this.$t('income_qty'), _style: 'width:10%'},
        {key: 'sumExistanceN', label: this.$t('outgoing_qty'), _style: 'width:10%'},
        {key: 'orginalExistance', label: this.$t('components.existence'), _style: 'width:10%'},
        // {key: 'summary', label: this.$t('tables.summary'), _style: 'width:10%'},

        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},

      ],
      normalizer_accounting(node) {
        return {
          id: node.id,
          label: node.accountCode + " " + node.accountName,
        }
      },
      normalizer_accounting_tafzili(node) {
        return {
          id: node.recId,
          label: node.title,
        }
      },
      load_products({action, searchQuery, callback}) {
        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);

            axios.post('GetProducts', formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {

                  console.log(error);
                });


            //  const options = this.get_keywords(searchQuery);
            // const options = [1, 2, 3, 4, 5].map(i => ({
            //     id: `${searchQuery}-${i}`,
            //     name: `${searchQuery}-${i}`,
            // }))

          })
        }
      },
      normalizer_products(node) {
        return {
          id: node.id,
          label: node.productCodeName,

        }
      },
      templates_items: [],
      accounting_list: [],
      moein_list: [],
      tafsili_list: [],
      selected_product: null,
      selected_moein: null,
      selected_tafsili: null,
      collapseDuration: 0,
      person_name: '',
      table_clicks:0,
      table_clicks_timer:null,
      status_form: 0
    }
  }, mounted() {

    this.$root.root_validate_errors = [];
    this.get_types();
    this.get_branch();
    this.get_places();
    this.get_categories()
    this.start_date = this.get_day_before_today(6);
    this.end_date = this.get_today();

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    'selected_tafsili': function () {
      // this.get_lists();
    }
  },
  methods: {
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        this.table_clicks=0;
        clearTimeout(this.table_clicks_timer);
        // console.log("item clicked in ",item)
        // bus.$emit('product_cardex_selected',{label:item.productName,
        //   productId:item.productId,
        // start_date:this.start_date,end_date:this.end_date})
window.open("/dashboard/products/inventory-cardex-reports/"+item.productCode+" "+item.productName+"/"+item.productId+"/"+this.start_date+"/"+this.end_date)
      }

    },
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    get_sum_existance(list) {
      var sum = 0;
      list.forEach((val) => {
        sum += val.sumExistance;
      })
      return sum;
    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = item.unitName;
      this.color = item.color;
      this.description = item.description;
      this.previewImage = item.image;
      this.status_form = item.id;
    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    }, edit_sale_method(item) {
      this.selected_method = item.saleMethodId;
      this.selected_person = item.userId;
      this.saleMethodModal = true;

    },
    select_moein(node) {
      var self = this;

      const formData = new FormData();
      var url = "GetAccountTafsiliList";
      formData.append("id", node.id);

      // self.tafzili_list = [];

      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {

              // item.tafzili_list = response.data.data;
              self.tafsili_list = response.data.data
            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      ).catch(function (error) {
        console.log(error);
      });

    },
    get_branch() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBranchList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.branch_items = [];
          self.branch_items = self.sort_array(
              self.branch_items, content_data.data,
              'branchId', 'branchTitle');

          self.selected_branch = self.branch_items[0].value

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_categories() {
      var self = this;


      const formData = new FormData();

      axios.post('GetAllCats', formData, {
        params: {
          // isparent : self.$route.params.cat_id
        },
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.category_items = [];
          var obj = {label: self.$t('dialogs.insertCategory'), value: 0}
          self.category_items.push(obj);
          self.category_items = self.sort_array(
              self.category_items, content_data.data,
              'catTitleId', 'catTitle');

          self.get_lists();

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_places() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetPlaces', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.places_items = content_data.data;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },


    get_childrens_one_sub(parent_id, list) {
      var array = [];
      var self = this;
      list.forEach((val2) => {

        if (parent_id == val2.parentId) {
          // var obj = {label: val2.accountCode + " " + val2.accountName, value: val2.id, code: val2.accountCode}
          array.push(val2);


        }
      });
      return array;
    },
    get_lists() {
      var self = this;
      //

      const formData = new FormData();

      var url = "GetCurrentExistsItems";
      if (this.selected_type_parent == 9) {

        formData.append('ProductId', 0);
      } else {
        if(this.selected_product==null){
          formData.append('ProductId', 0);

        }else{

          formData.append('ProductId', this.selected_product);
        }

      }
      formData.append('GrpId', this.selected_category);
      formData.append('Place', this.selected_place);
      formData.append('FromDate', this.start_date);
      formData.append('ToDate', this.end_date);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items_customer = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          self.items_customer.forEach(function (val) {

              val.sumExistanceP= val.inputQty

              val.sumExistanceN= val.outputQty
val.orginalExistance = val.bgInvQty+ val.inputQty + val.outputQty

          })
          // self.templates_items = content_data.data;
          // self.total_existance = self.items[0].orginalExistance
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goEditPerson(item) {

      this.$router.push({path: '/dashboard/users/edit-user/' + item.userId});

    },
    goToDocuments(item) {

      this.$router.push({path: '/dashboard/documents/show/' + item.masterId});

    },

    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = item.id;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeletePerson";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    get_types() {
      var self = this;


      const formData = new FormData();

      var url = "GetReportNumberList";

      // formData.append('id', "1532");
      //
      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;
        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          var data_get = self.sort_array([], content_data.data
              , "id", "title");
          self.types_all = data_get.filter(x => x.typeId == 2);
          self.types_parent = data_get.filter(x => x.parentId == 0 && x.typeId == 2);
          self.selected_type_parent = self.types_parent[0].value;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_child_options() {
      var array = [{label: this.$t('select'), value: 0}];
      var newArray = array.concat(this.types_all.filter(x => x.parentId == this.selected_type_parent));
      return newArray
    }

  }
}

</script>
